require('./buySellConditionTypeDropdown.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @helpers
const { formatText } = require('core/i18n').i18n;
const selectOption = require('./buySellConditionTypeSelectOption');
const {selectValue} = require('./buySellConditionTypeSelectValue');
const {
    BROKER_PRICE_GRATER_OR_EQUAL_CONDITION_ID,
    BROKER_PRICE_LESS_OR_EQUAL_CONDITION_ID,
    BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    EURO_TEXT
} = require('constants/index');

// @commons
const OKSelect = require('components/commons/OKSelect/OKSelect');

class BuySellConditionTypeDropdown extends React.Component {

    constructor(props) {
        super(props);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    buildOptions(optionsForMarketIndex) {
        const unit = (optionsForMarketIndex)?formatText('broker-pointsText'):EURO_TEXT;
        const options = [
            {
                label: formatText('broker-priceGraterOrEqualCondition', [unit]),
                value: BROKER_PRICE_GRATER_OR_EQUAL_CONDITION_ID
            },
            {
                label: formatText('broker-priceLessOrEqualCondition', [unit]),
                value: BROKER_PRICE_LESS_OR_EQUAL_CONDITION_ID
            },
            {
                label: formatText('broker-dailyLoweringPercentageGraterThanCondition'),
                value: BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID
            },
            {
                label: formatText('broker-dailyRasingPercentageGraterThanCondition'),
                value: BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID
            },
            {
                label: formatText('broker-intradayDownVariationGraterThanCondition', [unit]),
                value: BROKER_INTRADAY_DOWN_VARIATION_GRATER_THAN_CONDITION_ID
            },
            {
                label: formatText('broker-intradayDownVariationPercentageGraterThanCondition'),
                value: BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID
            },
            {
                label: formatText('broker-intradayUpVariationGraterThanCondition', [unit]),
                value: BROKER_INTRADAY_UP_VARIATION_GRATER_THAN_CONDITION_ID
            },
            {
                label: formatText('broker-intradayUpVariationPercentageGraterThanCondition'),
                value: BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID
            }
        ];

        return options;
    }

    handleSelectChange(option) {
        this.props.onConditionTypeChange(option.value);
    }

    render() {

        const { selectedValue, isConditionOnMarketIndex } = this.props;
        const placeholder = formatText('broker-conditionTypePlaceholder');
        const options = this.buildOptions(isConditionOnMarketIndex);
        const optionComponent = selectOption;
        const valueComponent = selectValue;

        return (

            <div className="buysell-condition-type-dropdown">
                <OKSelect
                    label={formatText('broker-buySellConditionType')}
                    onChange={this.handleSelectChange}
                    optionComponent={optionComponent}
                    valueComponent={valueComponent}
                    options={options}
                    value={selectedValue}
                    autosize={false}
                    placeholder={placeholder}
                />
            </div>

        );
    }

}

BuySellConditionTypeDropdown.propTypes = {
    onConditionTypeChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    isConditionOnMarketIndex: PropTypes.bool.isRequired
};

module.exports = BuySellConditionTypeDropdown;